// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

// ------------- Ouverture menu desktop ------------- //
const menuItems = document.querySelectorAll('.menu-item-has-children .menu__link');
const headerContent = document.querySelector('.header__content');

// Fonction qui cache le menu
function hideMenuItems() {
    menuItems.forEach(menuItem => {
        // On retire la classe 'visible-item' pour cacher les entrées du menu
        menuItem.classList.remove('visible-item');
        const subMenu = menuItem.nextElementSibling;
        // On vérifie que le submenu existe
        if (subMenu) {
            // On retire la classe 'visible-sub' pour cacher le submenu
            subMenu.classList.remove('visible-sub');
            subMenu.querySelectorAll('.submenu__link').forEach(submenuItem => {
                submenuItem.setAttribute('tabindex', '-1');
            });
        }
    });

    // On retire la classe 'overlay' pour cacher l'ensemble du menu
    headerContent.classList.remove('overlay');
}

// Fonction qui affiche le menu
function showMenuItem(menuItem) {
    // On ajoute la classe 'visible-item' pour afficher les entrées du menu
    menuItem.classList.add('visible-item');
    const subMenu = menuItem.nextElementSibling;
    if (subMenu) {
        // On ajoute la classe 'visible-sub' pour afficher le submenu
        subMenu.classList.add('visible-sub');
        subMenu.querySelectorAll('.submenu__link').forEach(submenuItem => {
            submenuItem.removeAttribute('tabindex');
        });
        // On ajoute un gestionnaire d'événements à chaque submenu pour permettre la fermeture des sous-sous-menus
        subMenu.querySelectorAll('.submenu').forEach(subSubMenu => {
            subSubMenu.addEventListener('click', function() {
                this.classList.toggle('visible-sub');
            });
        });
    }
    // On ajoute la classe 'overlay' pour afficher l'ensemble du menu
    headerContent.classList.add('overlay');
}

// Gestion de l'ouverture du menu
menuItems.forEach(menuItem => {
    menuItem.addEventListener('click', function() {
        if (menuItem.classList.contains('visible-item')) {
            // Si l'élément de menu est déjà visible, on le cache
            hideMenuItems();
        } else {
            // Sinon, on cache tous les éléments de menu et on affiche celui qui a été cliqué
            hideMenuItems();
            showMenuItem(menuItem);
        }
    });
});

// On ajoute un gestionnaire d'événements à tout le document pour cacher les éléments de menu si l'utilisateur clique à l'extérieur du menu
document.addEventListener('click', function(event) {
    if (!headerContent.contains(event.target)) {
        hideMenuItems();
    }
});

// Empêcher la redirection des liens d'ancrage au clic sur les entrées principales du menu (empêche qui de retourner en haut de la page)
const anchorLinks = document.querySelectorAll('a.menu__link[href^="#"]');

anchorLinks.forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault();
    });
});

// Fonction qui masque les tools en mobile à l'ouverture du menu
document.addEventListener('DOMContentLoaded', function() {
    let openMenuButton = document.getElementById('js-OpenMenu');
    let closeMenuButton = document.getElementById('js-CloseMenu');
    let tools = document.querySelector('.tools');

    openMenuButton.addEventListener('click', function() {
        tools.classList.add('open-menu');
        tools.style.transitionDuration = '0s';

        // Rétablir la durée de la transition à 0.5s après un court délai
        setTimeout(() => {
            tools.style.transitionDuration = '0.7s';
        }, 80);
    });

    closeMenuButton.addEventListener('click', function() {
        tools.classList.remove('open-menu');
    });
});

document.addEventListener('DOMContentLoaded', hideMenuItems);